"use client";
import { LocationContext } from "src/lib/contexts/ContextTypes";

//#region [Props]
type LocationWrapperProps = {
    children: React.ReactNode;
    firmId: number;

};
//#endregion

//#region [Component]
// The program for a single cinema (firm): the location is decided by firmId, so it can't be changed
export function FirmLocationWrapper({ children, firmId }: LocationWrapperProps) {
    return (<LocationContext.Provider value={{
        location: null,
        setLocation: (loc: string[]) => { },
        addLocation: (loc: string) => { },
        removeLocation: (loc: string) => { },
        showLocationDialog: false,
        setShowLocationDialog: (show: boolean) => { },
        isReady: true,
        showAllDates: false,
        firmId
    }}>
        {children}
    </LocationContext.Provider>);
}
//#endregion
